// extracted by mini-css-extract-plugin
export default {"brandPromo":"UE-z","carousel":"VE-z"};